import { Controller } from "@hotwired/stimulus"
import { escapeHtml } from "../util/common"

// Connects to data-controller="drawer-side-card"
export default class extends Controller {
  static targets = ["card"]

  showCard(event) {
    const data = event.target.dataset.drawerSideCardData ? JSON.parse(event.target.dataset.drawerSideCardData) : null
    if (!data) {
      this.hideCard()
      return
    }
    this.cardTarget.classList.remove("hidden")
    this.cardTarget.innerHTML = this.getCardHtml(data)
  }

  hideCard() {
    this.cardTarget.classList.add("hidden")
  }

  getCardHtml(data) {
    return `
      <div class="flex flex-col items-center size-full">
        <div class="relative w-320 h-300">
          ${
            data.country_code
              ? `<img src="/icons/flags/${escapeHtml(data.country_code.toLowerCase())}.svg" class="absolute top-10 left-10 size-40 rounded-10 object-cover">`
              : ""
          }
          <div class="absolute top-10 right-10 px-5 py-2 bg-darkblue text-white ui-text-body-compact font-medium uppercase rounded-5">${escapeHtml(data.profile_type)}</div>
          <img src="${escapeHtml(data.avatar_url)}" class="size-full object-cover rounded-20">
        </div>

        <div class="mt-10 ui-text-heading font-semibold">${escapeHtml(data.full_name)}</div>
        ${
          data.course
           ? `<div class="mt-2 text-14 leading-18">${escapeHtml(data.course)}</div>`
           : ""
        }
        ${
          data.tags?.length
            ? `<div class="flex flex-wrap justify-center gap-4 mt-14">
                ${data.tags.map(tag => `<span class="px-10 py-5 bg-seasalt-300 text-12 leading-14 rounded-50">${escapeHtml(tag)}</span>`).join(' ')}
              </div>`
            : ""
        }
        ${
          data.bio
          ? `<div class="mt-20 text-seasalt-500 text-14 leading-18 wrap-anywhere">${escapeHtml(data.bio)}</div>`
          : ""
        }
      </div>
    `
  }
}
